// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"9c45f50e","171":"bb0d8408","453":"3f7b104f","456":"94b263a6","507":"8bc40ec7","788":"b2853eea","968":"b3a7560f"}[chunkId] + ".chunk.js";
};